module.exports = __webpack_public_path__ + "static/img/end.ebff0aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/MagazineSpyglass/end.jpg
// module id = cGg3
// module chunks = 1